import React from 'react';
import './game-info-modal.styles.scss';
import Modal from '@/components/modal/modal.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';

const GameInfoModal = ({
    showGameInfoModal,
    setShowGameInfoModal,
    currentGame,
}) => {

  async function copyJoinCode() {
    try {
      await navigator.clipboard.writeText(`https://app.gamably.com/join/${currentGame.joinCode}`);
    } catch (err) {
      setAlertMessage('Failed to copy the Join Code. Please try again.');
      return;
    }
    document.getElementById(`${currentGame.joinCode}-tooltip`).style.visibility = 'visible';

    const timeout = setTimeout(() => {
      document.getElementById(`${currentGame.joinCode}-tooltip`).style.visibility = 'hidden';
      timeout && clearTimeout(timeout);
    }, 2000);

  }

  
  return (
    <div className="game-info-modal">
      <Modal
        show={showGameInfoModal}
        cancel={() => setShowGameInfoModal(false)}
        closeButton={true}
        text="Game Information"
        cls="scrolling"
      >
        <div className='game-info-modal-content'>
          <h3>{currentGame.gameName}</h3>
          <div className="g-space-1"></div>
          <div className='join-code'>
            Join Code:
            <strong>{currentGame.joinCode}</strong>
            <div className='g-tooltip'>
              <span
                className='g-tooltip-text'
                id={`${currentGame.joinCode}-tooltip`}>Copied!
              </span>
              <button
                className='g-button small-btn'
                title='Copy Link to Join'
                onClick={() => copyJoinCode()}>
                <FontAwesomeIcon icon={faLink} />
              </button>
            </div>
          </div>
          <div className="g-space-1"></div>
          <div className='game-info-content'>
            <div dangerouslySetInnerHTML={{ __html: currentGame.desc }} />
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default GameInfoModal